import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/pages/activities/card/press/index.ts